











 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewMeetingSettingsToggleAnonymity_settings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "disableAnonymity",
          "storageKey": null
        }
      ],
      "type": "RetrospectiveMeetingSettings",
      "abstractKey": null
    }
  ],
  "type": "TeamMeetingSettings",
  "abstractKey": "__isTeamMeetingSettings"
};

(node ).hash = "1102da878bd6b94a68cb31d4270d2715";

export default node;
